import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import LeftSidebar from './components/LeftSidebar';
import FerCalculator from './pages/FerCalculator';
import Footer from './components/Footer';
import './styles/App.css';

function App() {
  const [leftSidebarOpen, setLeftSidebarOpen] = useState(false); // Sidebar visibility state

  const toggleLeftSidebar = () => {
    setLeftSidebarOpen(!leftSidebarOpen);  // Toggles sidebar visibility
  };

  // 🛠️ Reset sidebar state when resizing
  useEffect(() => {
  const handleResize = () => {
    if (window.innerWidth >= 1024) {
      setLeftSidebarOpen(true); // Force open sidebar on desktop
    } else {
      setLeftSidebarOpen(false); // Hide sidebar on mobile
    }
  };

  handleResize(); // Run on mount (to set the correct initial state)
  window.addEventListener("resize", handleResize);

  return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div id="root">
      <Navbar toggleLeftSidebar={toggleLeftSidebar} />
      <div className="container">
      <LeftSidebar isOpen={leftSidebarOpen} toggleSidebar={toggleLeftSidebar} />
        <div className="main-content">
          <FerCalculator />
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default App;
